export const paidString = 'Mark as Paid';
export const unpaidString = 'Mark as Unpaid';
